module.exports = __webpack_public_path__ + "img/horse.c8116999.jpg";